import type { RootState } from "StoreTypes";

export const getFacilityDefaultRoundSettings = (
  state: RootState,
  facilityId: string,
) =>
  state.entities.defaultRoundSettings?.[
    state.entities.facilities?.[facilityId]?.defaultRoundSettingsId ?? ""
  ];
